import { render, staticRenderFns } from "./Qestion.vue?vue&type=template&id=75db86a6&scoped=true"
import script from "./Qestion.vue?vue&type=script&lang=js"
export * from "./Qestion.vue?vue&type=script&lang=js"
import style0 from "./Qestion.vue?vue&type=style&index=0&id=75db86a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75db86a6",
  null
  
)

export default component.exports